export const SkacValidateEmailDirective = (EmailService) => {
  'ngInject';
  return {
    require: 'ngModel',
    scope: {
      allowMultipleEmails: '='
    },
    link: skacValidateEmailLink
  };

  function skacValidateEmailLink(scope, elem, attrs, ngModel) {
    'ngInject';
    ngModel.$validators.skacValidateEmail = (modelValue, viewValue) => {
      let value = modelValue || viewValue;
      if (scope.allowMultipleEmails) {
        let status = EmailService.checkMultipleEmails(value);
        return status[0];
      } else {
        return EmailService.checkEmail(value);
      }
    }
  }
};
